import React, { Component } from "react";
import "./App.css";
import { ScrollToTopUtility } from "../Utilities/Utilities.js";
import loadable from "@loadable/component";
import NavigationBar from "../NavigationBar/NavigationBar.js";

const AboutMe = loadable(() => import("../AboutMe/AboutMe.js"));
const Portfolio = loadable(() => import("../Portfolio/Portfolio.js"));
const Contact = loadable(() => import("../Contact/Contact.js"));
const Footer = loadable(() => import("../Footer/Footer.js"));

class App extends Component {
    constructor() {
        super();
        this.state = {
            dark_mode: true,
        };
        this.updateAppDarkMode = this.updateAppDarkMode.bind(this);
    }

    // function that I pass to NavigationBar component for updating the dark_mode variable
    updateAppDarkMode(nav_dark_mode) {
        this.setState({ dark_mode: nav_dark_mode });
    }

    render() {
        const { dark_mode } = this.state;

        // hello header centered in wallpaper
        const intro = (
            <div className="intro">
                <img
                    className="background"
                    src={`${process.env.PUBLIC_URL}/images/Mountain.jpg`}
                    alt="background"
                />
                <div className="centered_text">
                    <h1> HI! I'M ALEX </h1>
                    <span> and this is my Portfolio page </span>
                </div>
            </div>
        );

        return (
            <div>
                <NavigationBar updateAppDarkMode={this.updateAppDarkMode} />
                {intro}
                <AboutMe dark_mode={dark_mode} />
                <Portfolio dark_mode={dark_mode} />
                <Contact dark_mode={dark_mode} />
                <Footer dark_mode={dark_mode} />
                <ScrollToTopUtility />
            </div>
        );
    }
}

export default App;
